import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "chips", "dropdown", "search", "options"]
  static values = { removeLabel: String }

  connect() {
    this.renderOptions()
    this.renderChips()
  }

  toggle(event) {
    this.dropdownTarget.hidden = !this.dropdownTarget.hidden
    event.currentTarget.setAttribute("aria-expanded", String(!this.dropdownTarget.hidden))
    if (!this.dropdownTarget.hidden) this.searchTarget.focus()
  }

  choose(event) {
    const option = this.optionFor(event.currentTarget.dataset.value)
    option.selected = !option.selected
    this.renderChips()
    this.renderOptions()
    this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  remove(event) {
    const option = this.optionFor(event.currentTarget.dataset.value)
    option.selected = false
    this.renderChips()
    this.renderOptions()
    this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  filter() {
    const query = this.searchTarget.value.trim().toLocaleLowerCase()
    this.optionsTarget.querySelectorAll("[data-value]").forEach((option) => {
      option.hidden = !option.dataset.label.toLocaleLowerCase().includes(query)
    })
  }

  close(event) {
    if (this.element.contains(event.target)) return

    this.dropdownTarget.hidden = true
    this.element.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false")
  }

  optionFor(value) {
    return Array.from(this.selectTarget.options).find((option) => option.value === value)
  }

  renderOptions() {
    this.optionsTarget.replaceChildren(...Array.from(this.selectTarget.options).map((option) => {
      const button = document.createElement("button")
      button.type = "button"
      button.dataset.value = option.value
      button.dataset.label = option.text
      button.textContent = option.text
      button.className = `block w-full px-3 py-2 text-left text-sm ${option.selected ? "bg-red-50 font-semibold text-red-700" : "text-slate-700 hover:bg-red-50 hover:text-red-700"}`
      button.addEventListener("click", (event) => this.choose(event))
      return button
    }))
    this.filter()
  }

  renderChips() {
    this.chipsTarget.replaceChildren(...Array.from(this.selectTarget.selectedOptions).map((option) => {
      const chip = document.createElement("span")
      chip.className = "inline-flex items-center gap-1 rounded-md bg-slate-100 px-2 py-1 text-xs font-medium text-slate-700"
      chip.textContent = option.text
      const remove = document.createElement("button")
      remove.type = "button"
      remove.dataset.value = option.value
      remove.setAttribute("aria-label", this.removeLabelValue.replace("%{label}", option.text))
      remove.className = "ml-1 text-slate-400 hover:text-red-600"
      remove.textContent = "×"
      remove.addEventListener("click", (event) => this.remove(event))
      chip.append(remove)
      return chip
    }))
    this.chipsTarget.dataset.empty = this.selectTarget.selectedOptions.length === 0
  }
}
